import { Component, OnInit } from "@angular/core";
import { IsTestLaunched } from "../../../shared/models/classes/IsTestLaunched/is-test-launched";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-dates-summary",
    templateUrl: "./dates-summary.component.html",
    styleUrls: ["./dates-summary.component.scss"],
})
export class DatesSummaryComponent implements OnInit {
    bbcImportDate: any;
    sicImportDate: any;
    sicbxlImportDate: any;
    lastProdDeploymentDate: any;
    isTestLaunched: IsTestLaunched;

    constructor(private dashboardService: DashboardBizzDevService) {}

    ngOnInit(): void {
        this.getBBCImportDate();
        this.getLastProdDeploymentDate();
        this.getSICBXLImportDate();
        this.getSICImportDate();
        this.getIsTestLaunchedState();
    }

    getBBCImportDate() {
        this.dashboardService
            .getProviderImportDate("bbc2020")
            .subscribe((value) => {
                this.bbcImportDate = value;
            });
    }

    getSICImportDate() {
        this.dashboardService
            .getProviderImportDate("sic")
            .subscribe((value) => {
                this.sicImportDate = value;
            });
    }

    getSICBXLImportDate() {
        this.dashboardService
            .getProviderImportDate("sicbxl")
            .subscribe((value) => {
                this.sicbxlImportDate = value;
            });
    }

    getLastProdDeploymentDate(): void {
        this.dashboardService.getLastProdDeploymentDate().subscribe((value) => {
            this.lastProdDeploymentDate = value;
        });
    }

    getIsTestLaunchedState(): void {
        this.dashboardService
            .getIsTestLaunchedState()
            .subscribe((value) => (this.isTestLaunched = value));
    }
}
